// Default-off switch for the one-tap first survey question.
// Build: REACT_APP_DOPLE_SURVEY_ONETAP_Q1
// Server: DOPLE_SURVEY_ONETAP_Q1, delivered as survey_onetap_q1.
// A present server value overrides the build-time flag. Missing means keep the build value.

export const SURVEY_ONETAP_Q1_CLIENT_ENV = "REACT_APP_DOPLE_SURVEY_ONETAP_Q1";
export const SURVEY_ONETAP_Q1_SERVER_ENV = "DOPLE_SURVEY_ONETAP_Q1";
export const SURVEY_ONETAP_Q1_PAYLOAD_KEY = "survey_onetap_q1";

const TRUTHY = new Set(["1", "true", "yes", "on"]);

let runtimeOverride = null;
const listeners = new Set();

export function parseSurveyOneTapFlag(value) {
  if (value === true) return true;
  return TRUTHY.has(String(value ?? "").trim().toLowerCase());
}

export function readBuildTimeSurveyOneTapQ1() {
  // CRA only inlines static process.env.REACT_APP_* reads. A dynamic lookup
  // behind typeof process compiles to {} in the browser bundle.
  return parseSurveyOneTapFlag(process.env.REACT_APP_DOPLE_SURVEY_ONETAP_Q1);
}

export function surveyOneTapQ1Enabled() {
  if (runtimeOverride !== null) return runtimeOverride;
  return readBuildTimeSurveyOneTapQ1();
}

function publish() {
  const next = surveyOneTapQ1Enabled();
  listeners.forEach((listener) => listener(next));
}

export function applyRuntimeSurveyOneTapQ1(payload) {
  if (!payload || typeof payload !== "object") return surveyOneTapQ1Enabled();
  const source = payload.features && typeof payload.features === "object" ? payload.features : payload;
  if (!Object.prototype.hasOwnProperty.call(source, SURVEY_ONETAP_Q1_PAYLOAD_KEY)) {
    return surveyOneTapQ1Enabled();
  }
  runtimeOverride = parseSurveyOneTapFlag(source[SURVEY_ONETAP_Q1_PAYLOAD_KEY]);
  publish();
  return runtimeOverride;
}

export function subscribeSurveyOneTapQ1(listener) {
  listeners.add(listener);
  listener(surveyOneTapQ1Enabled());
  return () => listeners.delete(listener);
}

export function resetSurveyOneTapQ1ForTests() {
  runtimeOverride = null;
  listeners.clear();
}
